import { useEffect, useRef } from 'react'
import confetti from 'canvas-confetti'
import { useInView } from 'framer-motion'

export default function ConfettiExplosion({
  trigger = true,
  colors = ['#E851B2', '#FF80BA', '#CE3798', '#FFB6B3', '#F9D2EB'],
  particleCount = 100,
  spread = 70,
  origin = { y: 0.6 }
}) {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })
  const hasTriggered = useRef(false)

  useEffect(() => {
    if (isInView && trigger && !hasTriggered.current) {
      hasTriggered.current = true

      // First burst
      confetti({
        particleCount,
        spread,
        origin,
        colors,
        ticks: 200,
        gravity: 0.8,
        scalar: 1.2,
        shapes: ['circle', 'square'],
        disableForReducedMotion: true
      })

      // Second burst with delay
      setTimeout(() => {
        confetti({
          particleCount: particleCount / 2,
          spread: spread + 20,
          origin: { ...origin, y: origin.y - 0.1 },
          colors,
          ticks: 150,
          gravity: 1,
          scalar: 0.8,
          shapes: ['circle'],
          disableForReducedMotion: true
        })
      }, 200)
    }
  }, [isInView, trigger, colors, particleCount, spread, origin])

  return <div ref={ref} className="absolute inset-0 pointer-events-none" />
}

export function triggerConfetti(options = {}) {
  const defaults = {
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#E851B2', '#FF80BA', '#CE3798', '#FFB6B3', '#F9D2EB'],
    disableForReducedMotion: true
  }

  confetti({ ...defaults, ...options })
}
